import BreakevenDetailsInquiry from './breakeven-details-inquiry.vue'
export default BreakevenDetailsInquiry
